import { render, staticRenderFns } from "./PollQuestionClickDesc.vue?vue&type=template&id=1dfa63af&scoped=true&"
import script from "./PollQuestionClickDesc.vue?vue&type=script&lang=js&"
export * from "./PollQuestionClickDesc.vue?vue&type=script&lang=js&"
import style0 from "./PollQuestionClickDesc.vue?vue&type=style&index=0&id=1dfa63af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa63af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VHover,VRow})
